import { getCurrentDateUnix } from './dates';

export function isUpcomingRelease(
  unixTimestamp: number | undefined,
  status: string | undefined
) {
  if (!unixTimestamp) return false;

  return (
    unixTimestamp > getCurrentDateUnix() ||
    (unixTimestamp === -1 && status === 'upcoming') ||
    status === 'coming-soon' ||
    status === 'tbc'
  );
}

export function isSoldOut(
  releaseDate: EpochTimeStamp | undefined,
  stockStatus: string
) {
  return (
    stockStatus === 'sold-out' && !isUpcomingRelease(releaseDate, stockStatus)
  );
}
